(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-hero-plate"] && !Shopify.designMode) return;
  try {
    
(function () {
  var boxes = document.querySelectorAll('[data-bb-hero-plate]');
  if (!boxes.length) return;
  Array.prototype.forEach.call(boxes, initPlate);

  function initPlate(box) {
    var mode = box.getAttribute('data-label-mode');
    if (mode === 'off') return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var touchSeen = false;
    var sticky = {};
    var lastDown = null;
    var hits = box.querySelectorAll('.bb-hero-plate__hit');
    var regions = box.querySelectorAll('.bb-hero-plate__region');
    var img = box.querySelector('.bb-hero-plate__picture img');
    var chipWrap = box.parentNode ? box.parentNode.querySelector('[data-bb-hero-chips]') : null;
    var chips = chipWrap ? chipWrap.querySelectorAll('[data-chip]') : [];
    function chipsFor(id) { return chipWrap ? chipWrap.querySelectorAll('[data-chip="' + id + '"]') : []; }

    /* smallest region wins where two overlap: larger areas sit lower */
    Array.prototype.slice.call(regions)
      .sort(function (a, b) { return parseFloat(b.getAttribute('data-area')) - parseFloat(a.getAttribute('data-area')); })
      .forEach(function (r, i) { r.style.zIndex = String(10 + i); });

    function sameFlower(el, id) {
      if (!el || !el.closest) return false;
      var o = el.closest('[data-flower]');
      return !!o && o.getAttribute('data-flower') === id;
    }

    function all(id) { return box.querySelectorAll('[data-flower="' + id + '"]'); }
    function setOn(id, on) {
      Array.prototype.forEach.call(all(id), function (el) { el.classList.toggle('is-on', on); });
      Array.prototype.forEach.call(chipsFor(id), function (c) { c.classList.toggle('is-on', on); });
      if (on && restIds.indexOf(id) === -1) evaporate();
    }
    var pinnedBehavior = box.getAttribute('data-pinned-behavior') || 'evaporate';
    var restSuspended = false;
    var returnTimer = null;
    var restIds = [];
    Array.prototype.forEach.call(box.querySelectorAll('.bb-hero-plate__hit[data-rest="true"]'), function (h) {
      var id = h.getAttribute('data-flower');
      if (restIds.indexOf(id) === -1) restIds.push(id);
    });
    function restOn(id) {
      if (restSuspended) return false;
      var hit = box.querySelector('.bb-hero-plate__hit[data-flower="' + id + '"]');
      return !!hit && hit.getAttribute('data-rest') === 'true';
    }
    /* the resting names evaporate the first time another name appears; they return after the cursor leaves the plate */
    function evaporate() {
      if (restSuspended || pinnedBehavior !== 'evaporate' || mode !== 'hover_pinned' || !restIds.length) return;
      restSuspended = true;
      restIds.forEach(function (rid) {
        if (sticky[rid]) return;
        var els = all(rid);
        Array.prototype.forEach.call(els, function (el) { el.classList.add('is-evap'); el.classList.remove('is-on'); });
        Array.prototype.forEach.call(chipsFor(rid), function (c) { c.classList.remove('is-on'); });
        setTimeout(function () { Array.prototype.forEach.call(els, function (el) { el.classList.remove('is-evap'); }); }, 900);
      });
    }
    function restoreRest() {
      clearTimeout(returnTimer);
      if (!restSuspended) return;
      restSuspended = false;
      restIds.forEach(function (rid) { if (!sticky[rid]) setOn(rid, true); });
    }
    function setSticky(id, on) {
      sticky[id] = on;
      Array.prototype.forEach.call(box.querySelectorAll('.bb-hero-plate__hit[data-flower="' + id + '"]'), function (h) {
        h.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      Array.prototype.forEach.call(chipsFor(id), function (c) { c.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      setOn(id, on || restOn(id));
    }
    function clearSticky() {
      Object.keys(sticky).forEach(function (id) { if (sticky[id]) setSticky(id, false); });
    }

    /* ---- measure: lines that meet a label's right edge end 6px past the rendered text ---- */
    function visibleLayer() {
      var layers = box.querySelectorAll('.bb-hero-plate__layer');
      for (var i = 0; i < layers.length; i++) {
        if (window.getComputedStyle(layers[i]).display !== 'none') return layers[i];
      }
      return null;
    }
    function measure() {
      var layer = visibleLayer();
      if (!layer) return;
      var br = box.getBoundingClientRect();
      if (!br.width) return;
      var labels = layer.querySelectorAll('.bb-hero-plate__label[data-side="right"]');
      Array.prototype.forEach.call(labels, function (label) {
        var id = label.getAttribute('data-flower');
        var line = layer.querySelector('.bb-hero-plate__line[data-flower="' + id + '"]');
        if (!line) return;
        var latin = label.querySelector('.bb-hero-plate__label-latin') || label;
        var lr = latin.getBoundingClientRect();
        var x2 = ((lr.right + 6) - br.left) / br.width * 100;
        line.setAttribute('x2', x2.toFixed(2));
      });
      /* dash length in screen px: with non-scaling-stroke the dash units are screen px, not user units */
      Array.prototype.forEach.call(layer.querySelectorAll('.bb-hero-plate__line'), function (line) {
        var dx = (parseFloat(line.getAttribute('x2')) - parseFloat(line.getAttribute('x1'))) / 100 * br.width;
        var dy = (parseFloat(line.getAttribute('y2')) - parseFloat(line.getAttribute('y1'))) / 100 * br.height;
        var len = Math.ceil(Math.sqrt(dx * dx + dy * dy)) + 2;
        line.style.setProperty('--bb-hp-len', len + 'px');
      });
    }
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(measure, 150);
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    measure();

    /* ---- hover, focus, keyboard ---- */
    Array.prototype.forEach.call(hits, function (hit) {
      var id = hit.getAttribute('data-flower');

      hit.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'touch' || touchSeen) return;
        setOn(id, true);
      });
      hit.addEventListener('pointerleave', function (e) {
        if (e.pointerType === 'touch' || touchSeen) return;
        if (sticky[id] || restOn(id)) return;
        if (sameFlower(e.relatedTarget, id)) return; /* moving onto this flower's own region */
        setOn(id, false);
      });
      hit.addEventListener('focus', function () { setOn(id, true); });
      hit.addEventListener('blur', function () {
        if (sticky[id] || restOn(id)) return;
        setOn(id, false);
      });
      hit.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          setSticky(id, !sticky[id]);
        } else if (e.key === 'Escape' || e.key === 'Esc') {
          clearSticky();
        }
      });
      hit.addEventListener('click', function (e) {
        if (e.detail === 0) return; /* keyboard activation is handled in keydown */
        if (lastDown && lastDown.type === 'touch') {
          if (lastDown.moved > 10 || (performance.now() - lastDown.t) > 300) return;
        }
        setSticky(id, !sticky[id]);
      });
    });

    Array.prototype.forEach.call(regions, function (region) {
      var id = region.getAttribute('data-flower');
      region.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'touch' || touchSeen) return;
        setOn(id, true);
      });
      region.addEventListener('pointerleave', function (e) {
        if (e.pointerType === 'touch' || touchSeen) return;
        if (sticky[id] || restOn(id)) return;
        if (sameFlower(e.relatedTarget, id)) return; /* moving onto this flower's own dot */
        setOn(id, false);
      });
      region.addEventListener('click', function () {
        if (lastDown && lastDown.type === 'touch') {
          if (lastDown.moved > 10 || (performance.now() - lastDown.t) > 300) return;
        }
        setSticky(id, !sticky[id]);
      });
    });

    /* ---- mobile chips: one species at a time; a tap pins it on the photo, a second tap releases it ---- */
    Array.prototype.forEach.call(chips, function (chip) {
      var id = chip.getAttribute('data-chip');
      chip.addEventListener('click', function () {
        var wasOn = !!sticky[id];
        clearSticky();
        if (!wasOn) {
          setSticky(id, true);
          if (chip.scrollIntoView) {
            try { chip.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduced ? 'auto' : 'smooth' }); } catch (err) { chip.scrollIntoView(); }
          }
        } else {
          restoreRest();
        }
      });
    });

    /* ---- resting names come back a moment after the cursor leaves the plate ---- */
    box.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'touch' || touchSeen) return;
      clearTimeout(returnTimer);
      if (restSuspended) returnTimer = setTimeout(restoreRest, 1200);
    });
    box.addEventListener('pointerenter', function () { clearTimeout(returnTimer); });

    /* ---- pointer bookkeeping and dismiss ---- */
    box.addEventListener('pointerdown', function (e) {
      lastDown = { type: e.pointerType, x: e.clientX, y: e.clientY, t: performance.now(), moved: 0 };
      if (e.pointerType === 'touch' && !touchSeen) {
        touchSeen = true;
        box.classList.add('is-touch');
      }
    }, { passive: true });
    box.addEventListener('pointermove', function (e) {
      if (!lastDown) return;
      var d = Math.hypot(e.clientX - lastDown.x, e.clientY - lastDown.y);
      if (d > lastDown.moved) lastDown.moved = d;
    }, { passive: true });
    box.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('.bb-hero-plate__hit') || t.closest('.bb-hero-plate__region') || t.closest('.bb-hero-plate__cta') || t.closest('a, [data-bb-scrollcue]')) return;
      if (lastDown && lastDown.type === 'touch') {
        if (lastDown.moved > 10 || (performance.now() - lastDown.t) > 300) return;
      }
      clearSticky();
      restoreRest();
    });
    box.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') { clearSticky(); restoreRest(); }
    });

    /* ---- intro sequence ---- */
    if (box.classList.contains('is-waiting') && !reduced) {
      var layer = visibleLayer();
      var restHits = layer ? layer.querySelectorAll('.bb-hero-plate__hit[data-rest="true"]') : [];
      var ids = Array.prototype.map.call(restHits, function (h) { return h.getAttribute('data-flower'); });
      ids.forEach(function (id) { setOn(id, false); });
      void box.offsetWidth; /* commit the off state while is-waiting still holds the paint */
      box.classList.remove('is-waiting');

      var started = false;
      function start() {
        if (started) return;
        started = true;
        measure();
        ids.forEach(function (id, i) {
          setTimeout(function () { if (!sticky[id]) setOn(id, true); }, i * 400);
        });
      }
      if (!img) { start(); }
      else if (img.decode) { img.decode().then(start, start); }
      else if (img.complete) { start(); }
      else { img.addEventListener('load', start, { once: true }); img.addEventListener('error', start, { once: true }); }
      setTimeout(start, 4000); /* never leave the plate blank */
    } else {
      box.classList.remove('is-waiting');
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-portfolio-editorial"] && !Shopify.designMode) return;
  try {
    
/* Contents line: pin under the site header once scrolled past, keep the page from jumping,
   mark the chapter in view. The hide-with-header motion is pure CSS (--header-is-visible). */
(function () {
  function init() {
  var holder = document.querySelector('[data-bb-pe-contents]');
  if (!holder || holder.dataset.bbPeBound === '1') return;
  holder.dataset.bbPeBound = '1';

  var nav = holder.querySelector('.bb-pe__contents');
  var sentinel = holder.querySelector('.bb-pe__contents-sentinel');
  var list = holder.querySelector('.bb-pe__contents-list');
  var root = holder.closest('.bb-pe');
  var links = Array.prototype.slice.call(holder.querySelectorAll('.bb-pe__contents-link[data-anchor]'));
  if (!nav || !sentinel || !list || !root || !links.length) return;

  var sticky = holder.dataset.sticky !== 'false';
  var pinned = false;
  var naturalH = 0;
  var raf = 0;

  function headerOffset() {
    var cs = getComputedStyle(document.documentElement);
    var isSticky = parseFloat(cs.getPropertyValue('--header-is-sticky')) || 0;
    var h = parseFloat(cs.getPropertyValue('--header-height')) || 0;
    return isSticky ? h : 0;
  }

  function measure() {
    root.style.setProperty('--bb-pe-strip-h', nav.offsetHeight + 'px');
    if (!pinned) naturalH = nav.offsetHeight;
  }

  function setPinned(on) {
    if (on === pinned) return;
    pinned = on;
    if (on) {
      /* Reserve the unpinned height so the page does not jump when the strip leaves the flow. */
      naturalH = nav.offsetHeight;
      holder.style.minHeight = naturalH + 'px';
      nav.classList.add('is-pinned');
    } else {
      nav.classList.remove('is-pinned');
      holder.style.minHeight = '';
    }
    measure();
  }

  function checkPin() {
    if (!sticky) return;
    var top = sentinel.getBoundingClientRect().top;
    setPinned(top <= headerOffset());
  }

  function onScroll() {
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = 0;
      checkPin();
    });
  }

  function revealActive(link) {
    if (!pinned || list.scrollWidth <= list.clientWidth) return;
    var li = link.parentElement;
    var left = li.offsetLeft;
    var right = left + li.offsetWidth;
    var viewL = list.scrollLeft;
    var viewR = viewL + list.clientWidth - 32;
    if (left < viewL) list.scrollLeft = Math.max(0, left - 16);
    else if (right > viewR) list.scrollLeft = right - list.clientWidth + 48;
  }

  function setActive(id) {
    links.forEach(function (a) {
      if (a.dataset.anchor === id) {
        if (a.getAttribute('aria-current') !== 'location') {
          a.setAttribute('aria-current', 'location');
          revealActive(a);
        }
      } else {
        a.removeAttribute('aria-current');
      }
    });
  }

  /* Pin state: sentinel-based, driven by scroll with rAF (IntersectionObserver rootMargin
     cannot follow a header whose height changes). */
  if (sticky) {
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { measure(); onScroll(); }, { passive: true });
    checkPin();
  }
  measure();

  /* Active chapter: the target whose box crosses the upper-middle band of the viewport. */
  var targets = links.map(function (a) { return document.getElementById(a.dataset.anchor); })
    .filter(Boolean);
  if ('IntersectionObserver' in window && targets.length) {
    var visible = new Map();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) visible.set(e.target.id, e.boundingClientRect.top);
        else visible.delete(e.target.id);
      });
      var best = null;
      var bestTop = Infinity;
      visible.forEach(function (top, id) {
        if (top < bestTop) { bestTop = top; best = id; }
      });
      if (best) setActive(best);
      else if (window.scrollY < 10) setActive('');
    }, { rootMargin: '-35% 0px -55% 0px', threshold: 0 });
    targets.forEach(function (t) { io.observe(t); });
  }
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();

/* Lightbox: every photo on the page (cover, frames, spreads, plates; not the closing portrait)
   opens larger in a dialog. Arrows, swipe and the arrow keys move through all photos in page
   order across both sections. Esc, the close button or a click outside the photo closes it. */
(function () {
  if (window.bbPeLightbox) {
    window.bbPeLightbox.enhance();
    return;
  }
  var SEL = '.bb-pe[data-lightbox="true"] .bb-pe__frame';
  var dlg, imgEl, capEl, countEl, prevBtn, nextBtn, items = [], index = 0, opener = null;
  var ICON = {
    close: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>',
    prev: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 4l-8 8 8 8"/></svg>',
    next: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 4l8 8-8 8"/></svg>'
  };

  function isEditor() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function frames() {
    return Array.prototype.slice.call(document.querySelectorAll(SEL)).filter(function (f) {
      return f.querySelector('img') && !f.closest('.bb-pe__colophon');
    });
  }

  function enhance() {
    if (isEditor()) return;
    frames().forEach(function (f) {
      if (f.hasAttribute('data-bb-pe-lb')) return;
      var img = f.querySelector('img');
      f.setAttribute('data-bb-pe-lb', '');
      f.setAttribute('tabindex', '0');
      f.setAttribute('role', 'button');
      f.setAttribute('aria-haspopup', 'dialog');
      f.setAttribute('aria-label', 'View larger: ' + (img.getAttribute('alt') || 'photo'));
    });
  }

  function build() {
    if (dlg) return;
    dlg = document.createElement('dialog');
    dlg.className = 'bb-pe-lb';
    dlg.setAttribute('aria-label', 'Photo viewer');
    dlg.innerHTML =
      '<p class="bb-pe-lb__count" aria-live="polite"></p>' +
      '<button type="button" class="bb-pe-lb__btn bb-pe-lb__close" aria-label="Close">' + ICON.close + '</button>' +
      '<button type="button" class="bb-pe-lb__btn bb-pe-lb__prev" aria-label="Previous photo">' + ICON.prev + '</button>' +
      '<button type="button" class="bb-pe-lb__btn bb-pe-lb__next" aria-label="Next photo">' + ICON.next + '</button>' +
      '<div class="bb-pe-lb__stage"><figure class="bb-pe-lb__fig">' +
      '<img class="bb-pe-lb__img" alt="" decoding="async">' +
      '<figcaption class="bb-pe-lb__cap"></figcaption></figure></div>';
    document.body.appendChild(dlg);
    imgEl = dlg.querySelector('.bb-pe-lb__img');
    capEl = dlg.querySelector('.bb-pe-lb__cap');
    countEl = dlg.querySelector('.bb-pe-lb__count');
    prevBtn = dlg.querySelector('.bb-pe-lb__prev');
    nextBtn = dlg.querySelector('.bb-pe-lb__next');

    dlg.querySelector('.bb-pe-lb__close').addEventListener('click', close);
    prevBtn.addEventListener('click', function () { go(-1); });
    nextBtn.addEventListener('click', function () { go(1); });
    imgEl.addEventListener('load', function () { imgEl.classList.add('is-loaded'); });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.classList.contains('bb-pe-lb__stage') || e.target.classList.contains('bb-pe-lb__fig')) close();
    });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });

    // Swipe left or right. Ignored while the visitor is pinch-zoomed into the photo.
    var sx = null, sy = 0;
    var stage = dlg.querySelector('.bb-pe-lb__stage');
    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      sx = e.clientX; sy = e.clientY;
    });
    stage.addEventListener('pointerup', function (e) {
      if (sx === null) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      sx = null;
      if (window.visualViewport && window.visualViewport.scale > 1.05) return;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) go(dx < 0 ? 1 : -1);
    });
    stage.addEventListener('pointercancel', function () { sx = null; });
  }

  // Ask the CDN for the width the photo will actually show at, not the full screen width.
  function sizesFor(src) {
    var w = parseFloat(src.getAttribute('width')) || src.naturalWidth || 3;
    var h = parseFloat(src.getAttribute('height')) || src.naturalHeight || 2;
    var vw = window.innerWidth, vh = window.innerHeight;
    var maxW = vw < 700 ? vw : vw - 144;
    var maxH = vh - (vw < 700 ? 170 : 140);
    return Math.max(200, Math.ceil(Math.min(maxW, maxH * (w / h)))) + 'px';
  }

  function show(i) {
    var n = items.length;
    if (!n) return;
    index = (i + n) % n;
    var frame = items[index];
    var src = frame.querySelector('img');
    var fig = frame.closest('figure');
    var cap = fig ? fig.querySelector('.bb-pe__caption') : null;

    imgEl.classList.remove('is-loaded');
    imgEl.removeAttribute('srcset');
    imgEl.setAttribute('sizes', sizesFor(src));
    if (src.getAttribute('srcset')) imgEl.setAttribute('srcset', src.getAttribute('srcset'));
    imgEl.src = src.currentSrc || src.getAttribute('src');
    imgEl.alt = src.getAttribute('alt') || '';
    if (imgEl.complete && imgEl.naturalWidth) imgEl.classList.add('is-loaded');

    capEl.textContent = cap ? cap.textContent.trim() : '';
    countEl.textContent = (index + 1) + ' / ' + n;
    prevBtn.hidden = nextBtn.hidden = n < 2;

    [index + 1, index - 1].forEach(function (j) {
      var nb = items[(j + n) % n].querySelector('img');
      if (!nb) return;
      var pre = new Image();
      pre.sizes = sizesFor(nb);
      if (nb.getAttribute('srcset')) pre.srcset = nb.getAttribute('srcset');
      pre.src = nb.getAttribute('src');
    });
  }

  function go(step) { show(index + step); }

  function open(frame) {
    build();
    items = frames();
    var i = items.indexOf(frame);
    if (i < 0) return;
    opener = frame;
    show(i);
    document.documentElement.classList.add('bb-pe-lb-lock');
    if (typeof dlg.showModal === 'function') dlg.showModal();
    else dlg.setAttribute('open', '');
    var nb = dlg.querySelector('.bb-pe-lb__close');
    if (nb) nb.focus({ preventScroll: true });
  }

  function close() {
    if (!dlg || !dlg.hasAttribute('open')) return;
    if (typeof dlg.close === 'function') dlg.close();
    else dlg.removeAttribute('open');
    document.documentElement.classList.remove('bb-pe-lb-lock');
    if (opener) opener.focus({ preventScroll: true });
    opener = null;
  }

  document.addEventListener('click', function (e) {
    if (isEditor()) return;
    var f = e.target.closest && e.target.closest('.bb-pe__frame[data-bb-pe-lb]');
    if (!f || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    open(f);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var f = e.target.closest && e.target.closest('.bb-pe__frame[data-bb-pe-lb]');
    if (!f || f !== e.target) return;
    e.preventDefault();
    open(f);
  });

  window.bbPeLightbox = { enhance: enhance };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance);
  else enhance();
  document.addEventListener('shopify:section:load', enhance);
})();

  } catch(e) { console.error(e); }
})();
})();
